import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const handleRequestClick = () => {
    navigate('/leave/request');
  };

  return (
    <div className="leave-footer-buttons">
      <button type="button" className="btn" onClick={handleRequestClick}>Request Leave</button>
      <button type="button" className="btn btn-outline">Add Leave</button>
    </div>
  );
}
